/**
 * Builds a PostalAddress object from location data
 * @param {Object} locationData 
 * @returns {Object|null} PostalAddress object or null if Zipcode or Address is not found
 */
function getAddressData(locationData) {
    if (!locationData || !locationData.Zipcode || !locationData.Address) {
        return null;
    }

    const regex = /^([\w\s.-]+),\s*([A-Z]{2})\s+(\d{5}(?:-\d{4})?)$/
    const [, city, state, zipcode] = locationData.Zipcode.trim().match(regex)

    if (!city || !state || !zipcode) {
        return null;
    }

    return {
        "@type": "PostalAddress",
        "streetAddress": locationData.Address,
        "addressLocality": city,
        "addressRegion": state,
        "postalCode": zipcode
    };
}

/**
 * Builds a GeoCoordinates object from location data
 * @param {Object} locationData 
 * @returns {Object|null} GeoCoordinates object or null if Coordinates is not found
 */
function getGeoData(locationData) {
    if (!locationData || !locationData.Coordinates) {
        return null;
    }

    const [latitude, longitude] = locationData.Coordinates.split(' ')

    if (!latitude || !longitude) {
        return null;
    }

    return {
        "@type": "GeoCoordinates",
        "latitude": latitude,
        "longitude": longitude
    }
}

/**
 * Builds a LocalBusiness JSON-LD schema from location data
 * @param {Object} locationData - Location data (e.g., from LocationDetailsBlock)
 * @param {Object} options - Optional configuration (url, etc.)
 * @returns {Object|null} LocalBusiness schema object or null if insufficient data
 */
export function buildLocalBusinessSchema(locationData, options = {}) {
    if (!locationData || !options || !options.Name || !options.Url || !locationData.PhoneNumber) {
        return null;
    }

    const addressData = getAddressData(locationData)
    const geoData = getGeoData(locationData)

    if (!addressData || !geoData) {
        return null;
    }

    return {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": options.Name,
        "url": options.Url,
        "telephone": locationData.PhoneNumber,
        "address": addressData,
        "geo": geoData,
        "parentOrganization": {
            "@type": "Organization",
            "name": "Wellby Financial Credit Union",
            "url": "https://www.wellbyfinancial.com/"
        }
    }
}